export const getLocalStorageIntValue = (key: string) => {
  const strValue = localStorage.getItem(key);

  if (!strValue) return undefined;

  const intValue = parseInt(strValue);

  if (isNaN(intValue)) return undefined;

  return intValue;
};
